import AssignmentPhaseModal from "@app/components/modals/assignments/assignment-phase-modal.tsx";
import useAssignmentData from "@app/data-hooks/use-assignment-data.ts";
import { assignmentPhaseTableDefinition } from "@app/table-definitions/assignment-phases.table-definition.tsx";
import { Button } from "@mui/material";
import { DataTable } from "bi-lib";
import { useState } from "react";

interface Props {
    id: number;
}

export default function AssignmentPhasesForm({ id }: Props) {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [phaseId, setPhaseId] = useState<number>();

    const { assignmentPhaseList, updateAssignmentPhaseActivation, updateAssignmentPhaseSortBy } = useAssignmentData({
        assignmentIds: id.toString(),
    });

    return (
        <>
            <AssignmentPhaseModal
                open={dialogOpen}
                onClose={() => {
                    setDialogOpen(false);
                    setPhaseId(undefined);
                }}
                phaseId={phaseId}
                assignmentId={id}
            />
            <DataTable
                rowsPerPageOptions={[5000]}
                label={"Phases"}
                actions={
                    <Button variant={"contained"} onClick={() => setDialogOpen(true)}>
                        Add New
                    </Button>
                }
                columns={assignmentPhaseTableDefinition({
                    onEdit: (id) => {
                        setDialogOpen(true);
                        setPhaseId(id);
                    },
                    onActivateDeactivate: (id, active) =>
                        updateAssignmentPhaseActivation.mutate({
                            phaseId: id,
                            isActive: active,
                        }),
                    onUpdateSortBy: (id, sortBy) => updateAssignmentPhaseSortBy.mutate({ phaseId: id, sortBy }),
                    minSort: 1,
                    maxSort: assignmentPhaseList.data?.length ?? 1,
                    rowCount: assignmentPhaseList.data?.length ?? 0,
                })}
                data={assignmentPhaseList.data ?? []}
                initialSorting={[{ id: "sortBy", desc: false }]}
                queryHook={assignmentPhaseList}
                initialColumnVisibility={{ sortBy: false }}
            />
        </>
    );
}
